<template >
	<div class="chat">
        <div class="conversas-content">
            <div class="mensagem" v-for="(m, i) in getConversa" :key="i" :class="{'msgCenter':(m.emissor.remetente=='redirect'), 'msgRight':(m.emissor.remetente=='agent'), 'msgLeft':(m.emissor.remetente=='client'), 'msgImage':(m.image)}"><span v-if="!m.image">{{m.mensagem}}</span><img class="avatarmessage" :src="m.image" v-if="m.image" @click="openimage('m.image')" />
                <v-spacer></v-spacer>
                <v-btn class="cyan darken-1 btnouvir" flat="flat" @click="ouvir(m.file)" v-if="m.emissor.remetente=='client' &amp;&amp; !!m.file" color="white">
                    <v-icon small="small">volume_up</v-icon>Ouvir</v-btn>
                <v-spacer v-if="m.visualizado"><span :class=" m.image ? 'black--text' : 'black--text'">{{ new Date(m.visualizado).toLocaleString() }}</span></v-spacer>
                <v-spacer v-if="m.emissor.remetente === 'agent' &amp;&amp; (!!m.receptor &amp;&amp; m.receptor.remetente === 'client')">
                    <v-icon v-if="!!!m.visualizado">check</v-icon>
                    <v-icon v-else :color="!!m.visualizado &amp;&amp;'blue lighten-3'">done_all</v-icon>
                </v-spacer>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    props:["protocolo"],
    data () {
      return {
		menus: [
			{
				avatar: 'https://eabiawak.com/wp-content/uploads/2017/07/photo.png',
				nome: "Capitão América",
				notification:9
			},
			{
				avatar: 'https://mbtskoudsalg.com/images/avatar-png-icon-7.png',
				nome: "Jhon Rambo",
				notification:8
			},
			{
				avatar: 'https://image.flaticon.com/icons/png/512/206/206879.png',
				nome: "Arnold chuazinéguer",
				notification:2
			},
			{
				avatar: 'https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png',
				nome: "Bob esponja",
				notification:3
			},
			{
				avatar: 'https://cdn.dribbble.com/users/691634/screenshots/1938437/self-icon-for-dribbble.png',
				nome: "Batman",
				notification:4
			},
			{
				avatar: 'https://eabiawak.com/wp-content/uploads/2017/07/photo.png',
				nome: "Gavião arqueiro",
				notification:55
			},
		],
      }
    },
    computed: {
        ...mapGetters(['getConversa'])
    },
    methods: {
        ...mapActions(['listaChamados', 'listaConversas']),
        ouvir(file)
        {
            // this.playerDialog=true
            const audio = window.document.createElement('audio')
            audio.autoplay = true
            audio.src = file
            window.document.body.appendChild(audio)
            audio.onended = () => window.document.body.removeChild(audio)
            setTimeout(()=> window.document.body.removeChild(audio), 7000)
        },
        openimage(img)
        {
            window.open(img)
        },
    },
    watch: {
        protocolo() {
            this.listaConversas(this.protocolo)
        }
    },
    mounted() {
    }
  }
</script>


<style lang="stylus" >
	.chat
		width 100%
		height calc(100vh - 70px)
		display flex
		flex-direction:column
		background url('https://storage.googleapis.com/gweb-uniblog-publish-prod/images/Background.max-2800x2800.jpg') fixed
		background-size 400px
		background-position center

	.conversas-content
		overflow-y auto
		height 100%
		padding 20px
		box-sizing border-box


	.msgCenter
		width 500px
		padding 5px !important
		color #3d3d3d !important
		text-align center
		background-color #F0F4C3
		margin auto
		margin-top 200px !important

	.msgRight
		width 300px
		float right
		position: relative
		background-color #e94247
		&:after
			content ''
			position absolute
			right 0
			top 50%
			width 0
			height 0
			border 12px solid transparent
			border-left-color #e94247
			border-right 0
			margin-top -12px
			margin-right -12px

	.msgLeft
		width 300px
		float left
		position relative
		background-color #1E4A9A
		&:after
			content ''
			position absolute
			left 0
			top 50%
			width 0
			height 0
			border 12px solid transparent
			border-right-color #1E4A9A
			border-left 5px
			margin-top -12px
			margin-left -12px

	.chatOptions
		position fixed
		bottom -27px
		width 900px
		display flex
		align-items center
		justify-content flex-start

	.mensagem
		padding 20px
		display block
		color #fff
		margin-bottom 10px
		clear both
		border-radius .8em
		box-shadow 3px 3px 3px silver

	.btnouvir
		float right

	.avatarmessage
		padding 3px
		width 290px

	.msgImage
		padding 4px !important
		padding-bottom 0px !important
		position: relative
		background-color rgba(255,255,255,.7)
		&:after
			content ''
			position absolute
			right 0
			top 50%
			width 0
			height 0
			border 12px solid transparent
			border-left-color rgba(255,255,255,.7)
			border-right 0
			margin-top -12px
			margin-right -12px

</style>



// WEBPACK FOOTER //
// src/components/user/pxtalk/Chat.vue